/**
 * Feature-local Knowledge Centre UI components (ADR-0006).
 *
 * Lifted out of `@pitchin/ui` (the `pin-kc-*` components) into the Learn feature so the Knowledge
 * Centre ships independently of the design-system library's release/revert state. Selectors are
 * `kc-*` (the `pin-kc-*` names live in the library, now in staging — same-named selectors would
 * collide). Deliberate duplication; re-promotion to `@pitchin/ui` is a later step, not a cleanup.
 */
export { KcPersonaSwitchComponent } from './kc-persona-switch.component';
export type { KcPersona } from './kc-persona-switch.component';
export { KcSearchBarComponent } from './kc-search-bar.component';
export { KcContentCardComponent } from './kc-content-card.component';
export {
  KC_LANES,
  KC_PRODUCT_LINES,
  kcContentCardClasses,
  kcPillClasses,
} from './kc-content-card.classes';
export type { KcLane, KcProductLine } from './kc-content-card.classes';
export { KcBrowseLaneComponent } from './kc-browse-lane.component';
export type { KcBrowseLane } from './kc-browse-lane.component';
export { KcAiAnswerComponent } from './kc-ai-answer.component';
export type { KcCitation } from './kc-ai-answer.component';
